export const vsServiceName = "selectRecordModal";
export const vsComponentName = "selectRecordModalComponent";
